const showImagePopup = (imageUrl) => {
  console.log(imageUrl);
  const overlay = document.createElement("div");
  overlay.className = "image-popup-overlay";

  const popup = document.createElement("div");
  popup.className = "image-popup";

  const img = document.createElement("img");
  img.src = imageUrl;

  const closeBtn = document.createElement("div");
  closeBtn.className = "image-popup-close";
  closeBtn.innerHTML = "&times;";

  // Append elements
  popup.appendChild(closeBtn);
  popup.appendChild(img);
  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  // Close on button click or outside click
  closeBtn.addEventListener("click", () => document.body.removeChild(overlay));
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) {
      document.body.removeChild(overlay);
    }
  });
};

const renderPreviewButton = (parent, src) => {
  const previewBtn = document.createElement("div");
  previewBtn.innerHTML = `<div class="tee-preview-design teeinblue-custom-preview-button" data-customization-id="1f836f94-2270-47f1-9212-c9398e9fac42"><div class="tee-preview-button__wrapper"><button class="tee-preview-button" type="button"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon--zoom icon--zoom-in tee-preview-button__icon--zoom-in" viewBox="0 0 512 512"><path d="M289.8 200.2h-49.3v-49.3c0-11.3-9.1-20.4-20.4-20.4s-20.4 9.1-20.4 20.4v49.3h-49.3c-11.3 0-20.4 9.1-20.4 20.4s9.1 20.4 20.4 20.4h49.3v49.3c0 11.3 9.1 20.4 20.4 20.4s20.4-9.1 20.4-20.4V241h49.3c11.3 0 20.4-9.1 20.4-20.4s-9.2-20.4-20.4-20.4"></path><path d="M220.2 388.7C127.3 388.7 52 313.5 52 220.6S127.3 52.5 220.2 52.5s168.1 75.3 168.1 168.1S313 388.7 220.2 388.7m274.8 78L381.7 353.4c29.7-36.1 47.6-82.4 47.6-132.8 0-115.5-93.6-209.2-209.2-209.2S11 105.1 11 220.6s93.6 209.2 209.2 209.2c50.4 0 96.6-17.8 132.7-47.5l113.3 113.3c5.2 5.3 21.1 7.9 28.9 0 7.9-8 7.9-20.9-.1-28.9"></path></svg><span class="tee-preview-button__text">Preview design</span></button></div></div>`;
  previewBtn.addEventListener("click", () => {
    document.querySelector("#corner-cowi-close-btn").click();
    showImagePopup(src);
  });
  parent.append(previewBtn);
};

function updateCartImagesAndRenderPreviewButton() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const items = data.items;
      const cartItems = document.querySelectorAll(
        "#corner-cowi-cart-item-list"
      );
      if (cartItems.length > 0) {
        items.forEach((item, index) => {
          if (item.properties && item.properties._customization_image) {
            const imageUrl = item.properties._customization_image;
            const cartItem = document.querySelector(
              `#corner-cowi-cart-item-${index}`
            );

            if (cartItem) {
              // replace default image with customization image
              const imageContainer = cartItem.querySelector("img");
              if (imageContainer) {
                if (imageContainer.src !== imageUrl) {
                  imageContainer.src = imageUrl;
                }
                imageContainer.style.opacity = 1;
              }

              // render preview button
              const itemDetailContainer = cartItem.querySelector(
                ".corner-cowi-cart-item-list-item-info-body"
              );
              const customPreviewButton = cartItem.querySelector(
                ".teeinblue-custom-preview-button"
              );
              if (itemDetailContainer && !customPreviewButton) {
                renderPreviewButton(itemDetailContainer, imageUrl);
              }
            }
          }
        });
      }
    })
    .catch((error) => {
      console.error("Error fetch cart.js:", error);
    });
}
document.addEventListener("CartDrawerOpen", () => {
  setTimeout(() => {
    updateCartImagesAndRenderPreviewButton();
  }, 1500);
});
